import { useFormContext } from "react-hook-form";
import { toast } from "@/hooks/use-toast";

export const useRates = () => {
  const { setValue, watch, trigger } = useFormContext();
  const rates = watch('rates') || [];

  const addRate = () => {
    const newRate = {
      roomTypeId: 0,
      bathroomTypeId: 0,
      categoryId: 0,
      currencyId: 0,
      price: 0
    };
    setValue('rates', [...rates, newRate]);
    if (rates.length > 0) {
      trigger('rates');
    }
  };

  const deleteRate = (index: number) => {
    const newRates = rates.filter((_, i) => i !== index);
    setValue('rates', newRates);
    if (newRates.length > 1) {
      trigger('rates');
    }
  };

  const handleRateChange = (index: number, field: string, value: number) => {
    const newRates = rates.map((rate, i) => 
      i === index ? { ...rate, [field]: value } : rate
    );
    
    if (rates.length > 1) {
      const completeRates = newRates.filter(rate => 
        rate.roomTypeId !== 0 && 
        rate.bathroomTypeId !== 0 && 
        rate.categoryId !== 0 && 
        rate.currencyId !== 0
      );

      if (completeRates.length > 1) {
        const combinations = new Set();
        const hasDuplicate = completeRates.some((rate) => {
          const key = `${rate.roomTypeId}-${rate.bathroomTypeId}-${rate.categoryId}-${rate.currencyId}`;
          if (combinations.has(key)) return true;
          combinations.add(key);
          return false;
        });

        if (hasDuplicate) {
          toast({
            variant: "destructive",
            title: "Error de validación",
            description: "No puede haber combinaciones duplicadas de tipo de habitación, baño, categoría y moneda",
          });
          return;
        }
      }
    }

    setValue('rates', newRates);
    if (rates.length > 1) {
      const completeRates = newRates.filter(rate => 
        rate.roomTypeId !== 0 && 
        rate.bathroomTypeId !== 0 && 
        rate.categoryId !== 0 && 
        rate.currencyId !== 0
      );
      if (completeRates.length > 1) {
        trigger('rates');
      }
    }
  };

  return {
    rates,
    addRate,
    deleteRate,
    handleRateChange
  };
}; 